export const validatePasswordString = ({ password, confirmedPassword }) =>
  password.length >= 12 && password === confirmedPassword;
